import InfoComp from '@pages/Admin/CRMSettings/components/InfoComp/InfoComp'
import classes from './index.module.css'

/** Публичная ссылка на сообщество: https://vk.com/club{id} */
/** Поля только для localhost (локальная разработка) */
export const isVkIntegrationLocalDevHost = (): boolean => {
  if (typeof window === 'undefined') {
    return false
  }

  const host = window.location.hostname
  return host === 'localhost' || host === '127.0.0.1'
}

const VK_CONNECT_SECRET_KEY_CHARS =
  'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'

/** Случайный secret_key (8 символов) для POST /v1/vk/connect-community */
export const generateVkConnectSecretKey = (): string => {
  const bytes = new Uint8Array(8)
  crypto.getRandomValues(bytes)
  return Array.from(
    bytes,
    (byte) =>
      VK_CONNECT_SECRET_KEY_CHARS[byte % VK_CONNECT_SECRET_KEY_CHARS.length],
  ).join('')
}

export const buildVkClubUrl = (groupId: string): string | null => {
  const digits = groupId.trim().replace(/^-/, '')
  if (!/^\d+$/.test(digits)) return null
  return `https://vk.com/club${digits}`
}

export const fieldLabelWithHint = (label: string, hint: string) => (
  <span className={classes.labelWithHint}>
    {label}
    <InfoComp text={hint} placement="top" />
  </span>
)
